/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon16Light = forwardRef('CheckA2Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.965 4.827a.5.5 0 1 0-.707-.707l-6.583 6.582a1.087 1.087 0 0 1-1.537 0L.87 8.435a.5.5 0 0 0-.707.707l2.267 2.267a2.088 2.088 0 0 0 2.953 0l6.582-6.582Z" }),
        React.createElement("path", { d: "M15.825 4.827a.5.5 0 1 0-.707-.707l-7.045 7.045a.5.5 0 1 0 .707.707l7.045-7.045Z" })));
});
